import React, { useState } from "react";

import "./artifacts.css";

function usd(n) {
	return "$" + Math.round(n).toLocaleString("en-US");
}

const TokenCostCalculator = () => {
	const [engineers, setEngineers] = useState(20);
	const [tokensPerDayK, setTokensPerDayK] = useState(400); // thousands of tokens per engineer per day
	const [pricePerM, setPricePerM] = useState(6); // blended $ per million tokens
	const [wastePct, setWastePct] = useState(30);

	const daysPerMonth = 22;
	const monthly =
		engineers *
		tokensPerDayK *
		1000 *
		daysPerMonth *
		(pricePerM / 1_000_000);
	const annual = monthly * 12;
	const wastedAnnual = annual * (wastePct / 100);

	const num = (setter) => (e) => {
		const val = parseFloat(e.target.value);
		setter(Number.isFinite(val) ? val : 0);
	};

	return (
		<div className="artifact-card">
			<div className="artifact-kicker">Interactive · Free tool</div>
			<div className="artifact-title">AI Token Cost Calculator</div>
			<div className="artifact-intro">
				Reflexive over-use is invisible on any single invoice. Size it
				across your team and a year.
			</div>

			<div className="artifact-input-row">
				<span className="artifact-label">Engineers using AI daily</span>
				<input
					className="artifact-input"
					type="number"
					min="1"
					value={engineers}
					onChange={num(setEngineers)}
				/>
			</div>
			<div className="artifact-input-row">
				<span className="artifact-label">
					Tokens per engineer per day (thousands)
				</span>
				<input
					className="artifact-input"
					type="number"
					min="0"
					value={tokensPerDayK}
					onChange={num(setTokensPerDayK)}
				/>
			</div>
			<div className="artifact-input-row">
				<span className="artifact-label">
					Blended price per 1M tokens (USD)
				</span>
				<input
					className="artifact-input"
					type="number"
					min="0"
					step="0.5"
					value={pricePerM}
					onChange={num(setPricePerM)}
				/>
			</div>
			<div className="artifact-input-row">
				<span className="artifact-label">
					Estimated reflexive over-use: {wastePct}%
				</span>
			</div>
			<input
				className="artifact-slider"
				type="range"
				min="0"
				max="70"
				value={wastePct}
				onChange={num(setWastePct)}
			/>

			<div className="artifact-metric-grid">
				<div className="artifact-metric">
					<div className="artifact-metric-value">{usd(monthly)}</div>
					<div className="artifact-metric-label">Per month</div>
				</div>
				<div className="artifact-metric">
					<div className="artifact-metric-value">{usd(annual)}</div>
					<div className="artifact-metric-label">Per year</div>
				</div>
				<div className="artifact-metric">
					<div
						className="artifact-metric-value"
						style={{ color: "#c53030" }}
					>
						{usd(wastedAnnual)}
					</div>
					<div className="artifact-metric-label">
						Waste, per year
					</div>
				</div>
			</div>
			<div className="artifact-readout" style={{ marginTop: "14px" }}>
				A stopping discipline that trims even half of that over-use pays
				for itself many times over.
			</div>
		</div>
	);
};

export default TokenCostCalculator;
